// components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

function SEO({ title, description, keywords }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords.join(", ")} />}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="author" content="Sukun Cloud Consulting" />
      <meta charSet="utf-8" />
    </Helmet>
  );
}

export default SEO;